import { __awaiter, __decorate, __extends, __generator } from "tslib";
/* eslint-disable */
import Vue from 'vue';
import Component from 'vue-class-component';
import { EntryApi } from '../apis';
var entryApi = new EntryApi(undefined);
var MailPage = /** @class */ (function (_super) {
    __extends(MailPage, _super);
    function MailPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.survey = null;
        _this.form = {
            email: '',
            name: ''
        };
        _this.rules = {
            required: function (value) { return !!value || '必須入力です'; }
        };
        _this.message = '';
        return _this;
    }
    MailPage.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.survey = this.$store.state.survey;
                return [2 /*return*/];
            });
        });
    };
    MailPage.prototype.send = function () {
        return __awaiter(this, void 0, void 0, function () {
            var entry, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.message = '';
                        entry = this.$store.state.entry;
                        if (!entry.id) {
                            return [2 /*return*/];
                        }
                        if (!this.form.email || this.form.email === '') {
                            this.message = 'メールアドレスを入力してください';
                            return [2 /*return*/];
                        }
                        if (!this.form.name || this.form.name === '') {
                            this.message = 'お名前を入力してください';
                            return [2 /*return*/];
                        }
                        request = {
                            to: this.form.email,
                            name: this.form.name
                        };
                        return [4 /*yield*/, entryApi.sendMail(entry.id, request).then(function (res) { return res.data; })];
                    case 1:
                        _a.sent();
                        if (this.survey && this.survey.finishUrl) {
                            window.location.href = this.survey.finishUrl;
                        }
                        else {
                            this.$emit('thanks');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MailPage = __decorate([
        Component({})
    ], MailPage);
    return MailPage;
}(Vue));
export default MailPage;
